export const seasonPassQueryKey = {
  all: ['season-passes'],
  list: (params: unknown) => [...seasonPassQueryKey.all, 'list', params],
  detail: (id: string) => [...seasonPassQueryKey.all, id],
};
